/* eslint-disable import/prefer-default-export */
import { UseQueryOptions, useQuery } from "@tanstack/react-query";
import { getQuotationActionHistory } from "api/services/shipment";
import { shipmentQueryKeys } from "./shipmentQueryKeys";

type GetQuotationActionHistoryOptions = {
  shipmentId: string;
  options?: UseQueryOptions;
  queryFn?: any;
};

export const useGetQuotationActionHistory = (data: GetQuotationActionHistoryOptions) =>
  useQuery<any>({
    queryKey: shipmentQueryKeys.shipmentQuotationActionHistoryDetails(data.shipmentId),
    queryFn: data.queryFn ? data.queryFn : () => getQuotationActionHistory(data.shipmentId).then((res) => res.data),
    ...data.options,
  });
